/**
 * SpotifyFooter.tsx
 *
 * Displays the Spotify widget inside the site footer IF the global
 * `spotifyFlag` is enabled. This lets you toggle the feature without
 * removing the component entirely.
 *
 * Requirements:
 * - `spotifyFlag` exported from types/spotify or config
 * - `Spotify` component that renders the "Currently Playing" card
 */

import Spotify from "components/layout/Spotify";
import { spotifyFlag } from "types/spotify";

export default function SpotifyFooter() {
  return (
    <footer className="mt-4 pb-2 justify-center">
      <main className="layout">
        {/* Render Spotify widget only if flag enabled */}
        {spotifyFlag && <Spotify className="mt-8" />}
      </main>
    </footer>
  );
}
